import { getClientRouteChrome } from 'navigation/clientRouteManifest';

export const getMobileRouteChrome = (pathname, options) =>
  getClientRouteChrome(pathname, options);

export const shouldShowMobileDock = (pathname, options) =>
  getMobileRouteChrome(pathname, options).showMobileDock;

export const shouldReserveMobileDockClearance = (pathname, options) =>
  getMobileRouteChrome(pathname, options).reserveDockClearance;
